import { PrizeList } from "./prize-list";

export class Prize extends PrizeList{
    public id: string;
    public outingIterationId: string;
}